import Vue from 'vue'
import VueRouter from 'vue-router'
import firebase from 'firebase'

// Containers
//const TheContainer = () => import('@/components/layout/TheContainer')
//const TheDarkContainer = () => import('@/components/layout/TheDarkContainer')

// Views
const Login = () => import('@/modules/auth/views/Login')
const Register = () => import('@/modules/auth/views/Register')
const ForgotPassword = () => import('@/modules/auth/views/ForgotPassword')


//const Profile = () => import('@/modules/user/views/Profile')
const Welcome = () => import('@/modules/user/views/Welcome')
//const OneTimePurchasePackages = () => import('@/modules/subscription/views/OneTimePurchasePackages')

// Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')


Vue.use(VueRouter)

const routes = [
  {
    path: '/web',
    redirect: '/web/profile',
    name: 'Home',
   // component: TheContainer,
    component: {
      render (c) { return c('router-view') }
    },
    children: [
      {
        path: 'profile',
        name: 'Profile',
       // component: Profile,
        component: Welcome,
        meta: {
          requiresAuth: true
        }
      },
      // {
      //   path: 'packages',
      //   name: 'Packages',
      //   component: OneTimePurchasePackages,
      //   meta: {
      //     requiresAuth: true
      //   }
      // },
    ]
  },
  {
    path: '/',
    redirect: '/web',
    name: 'Pages',
    component: {
      render (c) { return c('router-view') }
    },
    children: [
      {
        path: '404',
        name: 'Page404',
        component: Page404
      },
      {
        path: '500',
        name: 'Page500',
        component: Page500
      },
      {
        path: 'login',
        name: 'Login',
        component: Login
      },
      {
        path: 'register',
        name: 'Register',
        component: Register
      },
      {
        path: 'forgot-password',
        name: 'ForgotPassword',
        component: ForgotPassword
      },
      {
        path: 'welcome',
        name: 'Welcome',
        component: Welcome
      }
    ]
  },
  { path: "*", component: Page404 }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes
})

router.beforeEach((to, from, next) => {
  const currentUser = firebase.auth().currentUser;
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  if (requiresAuth && !currentUser) {
    next('/login');
  } else if (!requiresAuth && currentUser) {
    next('/web/profile');
  } else {
    next();
  }
});

export default router